import type { LlmModelPricing } from '@saaga/shared/interfaces/llm-model.interface'
import type { ReactNode } from 'react'

import { Badge } from '@/components/ui/badge'

export interface ModelInfoModalitiesProps {
  inputModalityList: string[]
  outputModalityList: string[]
  pricing?: LlmModelPricing
}

const formatPricePerMillion = (priceString: string): string => {
  const price = Number.parseFloat(priceString)
  if (price === 0) return 'Free'
  const pricePerMillion = price * 1_000_000
  if (pricePerMillion < 0.01) return `$${pricePerMillion.toFixed(4)}`
  if (pricePerMillion < 1) return `$${pricePerMillion.toFixed(3)}`
  return `$${pricePerMillion.toFixed(2)}`
}

export const ModelInfoModalities = ({
  inputModalityList,
  outputModalityList,
  pricing,
}: ModelInfoModalitiesProps): ReactNode => (
  <div className="model-info-modalities mb-3 flex items-center gap-1.5">
    <div className="flex flex-wrap gap-1.5">
      {inputModalityList.map((modality) => (
        <Badge key={`input-${modality}`} variant="secondary" className="text-xs font-normal">
          {modality} →
        </Badge>
      ))}
      {outputModalityList.map((modality) => (
        <Badge key={`output-${modality}`} variant="outline" className="text-xs font-normal">
          → {modality}
        </Badge>
      ))}
    </div>
    {pricing && (
      <div className="model-info-pricing ml-auto flex shrink-0 gap-2 text-xs text-muted-foreground">
        <span title="Input price per 1M tokens">In: {formatPricePerMillion(pricing.prompt)}/M</span>
        <span title="Output price per 1M tokens">
          Out: {formatPricePerMillion(pricing.completion)}/M
        </span>
      </div>
    )}
  </div>
)

ModelInfoModalities.displayName = 'ModelInfoModalities'
